"use strict";

let loadedTestScriptCount = 0;
let firstLoaded = false;

EWS.Ready((EWS) => {
    if (window.mocha) {
        mocha.setup("bdd");
    }

    const Grid = document.querySelector("#Dashboard .gridster ul");

    if (Grid) {
        LoadAllDashboardItems();

        if (!EC_Fmt.isMobile || navigator.userAgent.indexOf("iPad") !== -1 || (navigator.userAgent.toLowerCase().indexOf("mobile") === -1 && navigator.userAgent.toLowerCase().indexOf("android") > -1)) {
            EWS.Dashboard = new BC_Gridster(Grid, {
                namespace: "#Dashboard div.gridster"
            });

            const inner = document.querySelector("#Content .Inner");

            if (inner) {
                inner.style.overflow = "hidden";

                setTimeout(() => {
                    inner.style.overflow = "auto";
                }, 500);
            }
        } else {
            const Menu = document.getElementById("Menu");

            if (Menu?.classList.contains("MenuOpened") && !Menu.classList.contains("FullMenu") && !Menu.classList.contains("MenuCollapsed")) {
                Grid.style.width = `${window.innerWidth - Menu.offsetWidth - 10}px`;
            } else {
                Grid.style.width = `${window.innerWidth - 10}px`;
            }
            document.getElementById("MobileBodyWrap").classList.add("phone-grid");
        }

        const liArr = Grid.querySelectorAll("li");

        for (let i = 0; i < liArr.length; i++) {
            const li = liArr[i];
            li.style.display = "block";
        }
    } else {
        LoadAllDashboardItems();

        const dashboardItemArr = document.querySelectorAll(".dashboard-item");

        for (let i = 0; i < dashboardItemArr.length; i++) {
            const dashboardItem = dashboardItemArr[i];
            dashboardItem.style.display = "block";
        }
    }

    const ewsDashboard = document.querySelector(".ews-dashboard");

    if (ewsDashboard) {
        ewsDashboard.addEventListener("scroll", () => {
            const AutocompleteMenuArr = document.querySelectorAll(".AutocompleteMenu");

            // Task 838089: Uncaught Type Error on Invoice Manual Edit
            for (let i = 0; i < AutocompleteMenuArr.length; i++) {
                const AutocompleteMenu = AutocompleteMenuArr[i];
                AutocompleteMenu.style.display = "none";
            }
        }, { passive: true });
    }
});

function Dashboard_Fullscreen(DashboardID) {
    EWS.VerifySession(() => {
        ECP.Dialog.ShowLoading();

        const myFullscreenSetupDialogRequest = new ECP.EC_Request("Dashboard_FullscreenSetupDialog");

        myFullscreenSetupDialogRequest.Submit().then((result) => {
            const dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 650,
                height: 700,
                cancelButtonTitle: result.cancel,
                confirmButtonTitle: result.start,
                confirmButtonAction() {
                    const dashboards = [];
                    const checkedDashboardArr = dialog.querySelectorAll("input[name='DashboardID']:checked");

                    for (let i = 0; i < checkedDashboardArr.length; i++) {
                        const checkedDashboard = checkedDashboardArr[i];
                        dashboards.push(parseInt(checkedDashboard.value));
                    }

                    if (dashboards.length === 0) {
                        ECP.Dialog.Alert("Please select at least one dashboard!");
                        dialog.style.display = "flex";

                        return;
                    }

                    ECP.Dialog.ShowLoading();

                    const fullscreenArgs = {
                        rotate: (parseInt(dialog.querySelector("#ews-fullscreen-rotate").value)),
                        dashboards,
                        current: 1
                    };

                    const mySaveFullRequest = new ECP.EC_Request("Dashboard_SaveFullscreenDashboards");

                    mySaveFullRequest.SetReturnType(ECP.EC_ReturnType.Text);
                    mySaveFullRequest.AddRequestVariable("DashboardList", fullscreenArgs.dashboards.join(), ECP.EC_Verb.Post);
                    mySaveFullRequest.AddRequestVariable("RotateRate", fullscreenArgs.rotate, ECP.EC_Verb.Post);

                    mySaveFullRequest.Submit().then(() => {
                        window.location.href = `Home?DashboardID=169588&RotateRate=${fullscreenArgs.rotate}&DashboardIDList=${fullscreenArgs.dashboards.join()}`;
                    }).catch((err) => {
                        ECP.Dialog.HideLoading();
                        throw err;
                    });
                }
            });

            dialog.querySelector(".ecp-dialog-content").style.overflow = "hidden";

            const myGetFullscreenDashboardsRequest = new ECP.EC_Request("Dashboard_GetFullscreenDashboards");

            myGetFullscreenDashboardsRequest.Submit().then((dashboardsResult) => {
                let html = "<ul class=ews-fullscreen-dashboard-list>";

                if (dashboardsResult.selected.indexOf(DashboardID) < 0) {
                    dashboardsResult.selected.push(DashboardID);
                }

                for (let i = 0; i < dashboardsResult.dashboard.length; i++) {
                    html += "<li>"
                        + "<table class=NoPadding>"
                        + "<tr>"
                        + "<td style=\"padding:1px 5px 0 5px\">";

                    if (dashboardsResult.selected.indexOf(dashboardsResult.dashboard[i].id) >= 0) {
                        html += `<input id=DashboardID_${i} type=checkbox style=margin:0 name=DashboardID value="${dashboardsResult.dashboard[i].id}" checked>`;
                    } else {
                        html += `<input id=DashboardID_${i} type=checkbox style=margin:0 name=DashboardID value="${dashboardsResult.dashboard[i].id}">`;
                    }

                    html += "</td>"
                        + "<td style=\"padding:0 5px 0 0;cursor:default\">"
                        + ` <label for="DashboardID_${i}">${dashboardsResult.dashboard[i].category} - ${dashboardsResult.dashboard[i].name}</label>`
                        + "</td>"
                        + "</tr>"
                        + "</table>"
                        + "</li>";
                }

                html += "</ul>";

                dialog.querySelector("#ews-fullscreen-rotate").value = dashboardsResult.rotate;

                dialog.querySelector("#ews-fullscreen-dashboards").innerHTML = html;

                ECP.Dialog.HideLoading();
            });
        }).catch((err) => {
            ECP.Dialog.HideLoading();
            throw err;
        });
    });
}

async function LoadAllDashboardItems() {
    const dashboardItemArr = document.querySelectorAll("#Dashboard .gridster > ul > li, .container-fluid .dashboard-item");
    // Task 909469: Experiencing Site Slowness on Eriebeer.encompass8.com as well as Support.Encompass8.com
    const promiseArr = [];

    for (let i = 0; i < dashboardItemArr.length; i++) {
        const dashboardItem = dashboardItemArr[i];

        // Task 737678: Dashboard: LoadDashboardItem not support Dashboard Widget
        let url = dashboardItem.getAttribute("url");

        if (firstLoaded && !url) {
            const widgetId = dashboardItem.getAttribute("widgetId");

            if (widgetId !== "7") {
                url = `api?APICommand=DashboardWidget_WriteWidgetCode&DashboardItemID=${dashboardItem.getAttribute("id")}&DashboardWidgetID=${widgetId}`;

                if (EC_Fmt.GetPageParameter("WidgetRelease") && EC_Fmt.GetPageParameter("WidgetRelease").toLowerCase() === "false") {
                    url += "&WidgetRelease=False";
                }
            }
        }

        promiseArr.push(LoadDashboardItem(dashboardItem, url));
    }

    await Promise.all(promiseArr);
    const dashboardContainer = document.querySelector(".ews-dashboard");

    if (dashboardContainer) {
        dashboardContainer.style.overflow = "hidden";

        setTimeout(() => {
            dashboardContainer.style.overflow = "initial";
        }, 500);
    }

    firstLoaded = true;

    // Task 723798: AR Aging, not taken back to the same place in the list after applying payments
    if (window.history.state && (window.history.state.scrollLeft !== undefined || window.history.state.scrollTop !== undefined)) {
        const innerContent = document.querySelector("#Content .Inner");

        if (innerContent) {
            innerContent.scrollTo(window.history.state.scrollLeft, window.history.state.scrollTop);
        }
    }
}

async function LoadDashboardItem(Item, URL) {
    const Content = Item.querySelector(".content");

    if (URL) {
        if (window.PageParameters?.Search.QuickKey && PageParameters.Search.QuickKey.length > 0) {
            URL += `&QuickKey=${PageParameters.Search.QuickKey[0]}`;
        }

        Content.innerHTML = "";

        if (navigator.cookieEnabled) {
            const response = await fetch(URL, {
                credentials: "same-origin"
            });

            const html = await response.text();
            await InitDashboardItem(Content, html, Item);
        } else {
            await InitDashboardItem(Content, "Cookies not enabled<br>Cookies are required to use this site for authentication", Item);
        }
    } else {
        await InitDashboardItem(Content, "", Item);
    }
}

async function InitDashboardItem(Content, html, Item) {
    let CurrentFooter = Item.querySelector(".ContentFooter");

    // Task 917004: Errors on Override Codes: TypeError: Cannot set property 'innerHTML' of null
    if (html !== "") {
        Content.innerHTML = html;
    }

    EC_Fmt.ReLoadScripts(Content.querySelectorAll("script"), () => { });

    // EC-21911
    Content.addEventListener("click", (e) => {
        if (e.target.tagName === "A") {
            let reportId = null;
            let isSystem = false;

            // Try new format with data attributes
            if (e.target.classList.contains("report-link")) {
                reportId = e.target.getAttribute("data-report-id");
                isSystem = e.target.getAttribute("data-is-system") === "true";
            }

            // Try old format with data-mce-href or href containing blocked-js or javascript:
            if (!reportId) {
                const href = e.target.getAttribute("data-mce-href") || e.target.getAttribute("href") || "";
                if (href.indexOf("EWS.SavedReport.Run") !== -1) {
                    // Parse: blocked-js:EWS.SavedReport.Run(6066128);
                    // or javascript:EWS.SavedReport.Run('reportId', true/false);
                    const match = href.match(/EWS\.SavedReport\.Run\s*\(\s*['"]?([^'",)]+)['"]?\s*(?:,\s*(true|false))?\s*\)/);
                    if (match) {
                        reportId = match[1];
                        isSystem = match[2] === "true";
                    }
                }
            }

            // Execute if we found a report
            if (reportId && typeof EWS !== "undefined" && EWS.SavedReport) {
                e.preventDefault();
                EWS.SavedReport.Run(reportId, isSystem);
                return false;
            }
        }
    });

    if (Item.getAttribute("url") || Item.getAttribute("widgetId") !== "7") {
        const ajaxInputArr = Content.querySelectorAll("input[KeyValue][DisplayVal][LimitToList]");

        for (let i = 0; i < ajaxInputArr.length; i++) {
            const ajaxInput = ajaxInputArr[i];
            const FieldID = ajaxInput.parentElement.parentElement.getAttribute("FieldID");
            EWS.AjaxInputs[FieldID] = new ECP.HTML.AjaxInput(ajaxInput);
        }
    }

    const tipsContainerArr = Item.querySelectorAll(".header .ews-dashboard-tips-container");

    for (let i = 0; i < tipsContainerArr.length; i++) {
        const tipsContainer = tipsContainerArr[i];
        tipsContainer.parentElement.removeChild(tipsContainer);
    }

    if (CurrentFooter) {
        CurrentFooter.parentElement.removeChild(CurrentFooter);
    }

    CurrentFooter = Content.parentElement.querySelector(".ContentFooter");

    if (CurrentFooter) {
        Item.appendChild(CurrentFooter);
        Content.style.borderBottom = `${CurrentFooter.offsetHeight + 8}px solid transparent`;
    } else {
        Content.style.borderBottom = "0 none";
    }

    // Run code js
    const scriptFunction = window[`codeItemJs${Item.getAttribute("id").replace("-", "N")}`];

    if (scriptFunction) {
        await scriptFunction(Item);
    }

    const itemType = Item.getAttribute("item-type");

    if (itemType) {
        const itemFields = Get_DashboardItem_ItemFields(Item);
        const loadedResult = EWS.DashboardItemTypesManager.onLoaded(itemType, Item, itemFields);

        if (loadedResult instanceof Promise) {
            await loadedResult;
            EWS.DashboardItemTypesManager.createViewButtons(itemType, Item, itemFields);
        } else if (loadedResult instanceof Function) {
            // EC-17465: Add 'Lazy Loading' for reports on dashboards - Wait to run the report until the user begins scrolling down
            const observer = new IntersectionObserver(async (entries, myObserver) => {
                if (entries[0].isIntersecting) {
                    // Stop observing once we've detected intersection
                    myObserver.unobserve(Item);
                    await loadedResult();
                    EWS.DashboardItemTypesManager.createViewButtons(itemType, Item, itemFields);
                }
            }, {
                threshold: 0,
                rootMargin: "10% 10% 10% 10%" // Extends detection area by 10% in all directions
            });
            observer.observe(Item);
        } else {
            EWS.DashboardItemTypesManager.createViewButtons(itemType, Item, itemFields);
        }
    }

    const testDocumentId = Item.getAttribute("data-itemfield-testdocumentid");
    const globalTestDocumentId = Item.getAttribute("data-itemfield-globaltestdocumentid");

    if (testDocumentId || globalTestDocumentId || Item.getAttribute("is-published")) {
        loadedTestScriptCount += 1;

        if (loadedTestScriptCount === (document.querySelectorAll(".dashboard-item[data-itemfield-testdocumentid]").length + document.querySelectorAll(".dashboard-item[data-itemfield-globaltestdocumentid]").length + document.querySelectorAll(".dashboard-item[is-published]").length)) {
            if (window.mocha) {
                // Timings are recorded as each test finishes so the code block test runner can report slow tests even when a run times out
                window.MochaTestTimings = [];
                window.MochaHookTimings = [];
                window.MochaRunningTest = null;

                const runner = mocha.run(() => {
                    if (window.__coverage__ && !window.MochaTested) {
                        ProcessTestScriptResult(window.__coverage__, document);
                    }

                    window.MochaTested = true;
                });

                runner.on("test", (test) => {
                    window.MochaRunningTest = { name: test.fullTitle(), startedAt: Date.now() };
                });

                runner.on("test end", (test) => {
                    window.MochaTestTimings.push({ name: test.fullTitle(), durationMs: test.duration || 0, state: test.state || "pending" });
                    window.MochaRunningTest = null;
                });

                runner.on("hook end", (hook) => {
                    if (!hook.duration) {
                        return;
                    }

                    // beforeEach/afterEach titles include the current test name, so aggregate on the hook's own title
                    const hookName = hook.originalTitle || hook.title;
                    const hookTiming = window.MochaHookTimings.find(existing => existing.name === hookName);

                    if (hookTiming) {
                        hookTiming.durationMs += hook.duration;
                        hookTiming.count += 1;
                        return;
                    }

                    window.MochaHookTimings.push({ name: hookName, durationMs: hook.duration, count: 1 });
                });
            }
        }
    }

    const header = Item.querySelector(".header");

    if (EC_Fmt.isMobile) {
        header.style.backgroundColor = getComputedStyle(Item).backgroundColor;
    }
}

function ProcessTestScriptResult(__coverage__, contentDocument, isUnload) {
    const dashboardItemIdArr = Object.keys(__coverage__);

    for (let i = 0; i < dashboardItemIdArr.length; i++) {
        const dashboardItemID = dashboardItemIdArr[i];
        const codeCoverage = __coverage__[dashboardItemID];
        let count = 0;
        const fKeyArr = Object.keys(codeCoverage.f);

        for (let j = 0; j < fKeyArr.length; j++) {
            const fKey = fKeyArr[j];
            if (codeCoverage.f[fKey] > 0) {
                count += 1;
            }
        }

        const fCoverage = Object.getOwnPropertyNames(codeCoverage.f).length > 0 ? (count / Object.getOwnPropertyNames(codeCoverage.f).length) : "";
        count = 0;
        let total = 0;
        const bKeyArr = Object.keys(codeCoverage.b);

        for (let j = 0; j < bKeyArr.length; j++) {
            const bKey = bKeyArr[j];
            total += codeCoverage.b[bKey].length;

            for (let k = 0; k < codeCoverage.b[bKey].length; k++) {
                if (codeCoverage.b[bKey][k] > 0) {
                    count += 1;
                }
            }
        }

        const bCoverage = total > 0 ? (count / total) : "";
        count = 0;
        const sKeyArr = Object.keys(codeCoverage.s);

        for (let j = 0; j < sKeyArr.length; j++) {
            const sKey = sKeyArr[j];
            if (codeCoverage.s[sKey] > 0) {
                count += 1;
            }
        }

        const sCoverage = Object.getOwnPropertyNames(codeCoverage.s).length > 0 ? (count / Object.getOwnPropertyNames(codeCoverage.s).length) : "";
        let testReportTitle;
        const elements = contentDocument.querySelectorAll("#mocha-report a");

        for (let j = 0; j < elements.length; j++) {
            const element = elements[j];
            if (RegExp(`Dashboard Item ${dashboardItemID}`).test(element.textContent)) {
                testReportTitle = element;
                break;
            }
        }

        if (testReportTitle) {
            const info = EC_Fmt.HtmlStrToElement(`<h2 class="code-coverage" statement-coverage="${sCoverage}">Statements: ${sCoverage !== "" ? `${sCoverage.toFixed(2) * 100}%` : sCoverage};&nbsp;&nbsp;&nbsp;&nbsp;Functions: ${fCoverage !== "" ? `${fCoverage.toFixed(2) * 100}%` : fCoverage};&nbsp;&nbsp;&nbsp;&nbsp;Branches: ${bCoverage !== "" ? `${bCoverage.toFixed(2) * 100}%` : bCoverage};</h2>`);
            testReportTitle.parentElement.parentElement.insertBefore(info, testReportTitle.parentElement.nextElementSibling);
        }
    }

    if (isUnload && contentDocument.getElementById("mocha")) {
        const warning = EC_Fmt.HtmlStrToElement("<div class=code-warning style=\"margin:5px 0;background:var(--yellow-20);border:3px solid var(--yellow-40);font-weight:700;font-size:13px;padding:5px;color:var(--text-secondary)\">The test script run failed because the test page has been unload.</div>");
        contentDocument.getElementById("mocha").insertBefore(warning, contentDocument.getElementById("mocha").firstElementChild);
    }
}

// EC-4716: DashboardEdit.js and Home.js do not parse Dashboard ItemFields the same
function Get_DashboardItem_ItemFields(DashboardItem) {
    const DashboardItemFields = {};
    // EC-4808: Dashboard Load: Allow loading multiple Dashboard Field Items of varying length into ItemFields on a Dashboard
    const ItemFieldArr = EWS.DashboardItemTypesManager.getItemFields(DashboardItem.getAttribute("item-type"));

    for (let i = 0; i < ItemFieldArr.length; i++) {
        let ItemFieldName = ItemFieldArr[i];

        if (ItemFieldName.startsWith("*")) {
            ItemFieldName = ItemFieldName.substring(1);
            const LookupName = `data-itemfield-${ItemFieldName.toLowerCase()}`;

            const DashboardItemAttrArr = DashboardItem.attributes;
            for (let j = 0; j < DashboardItemAttrArr.length; j++) {
                const CurrentAttribute = DashboardItemAttrArr[j];

                if (CurrentAttribute.name.startsWith(LookupName)) {
                    DashboardItemFields[ItemFieldName + CurrentAttribute.name.split(LookupName)[1]] = CurrentAttribute.value;
                }
            }
        } else {
            DashboardItemFields[ItemFieldName] = DashboardItem.getAttribute(`data-itemfield-${ItemFieldName.toLowerCase()}`);
        }
    }

    return DashboardItemFields;
}

// Task 639455: TinyMCE editor is being loaded on every single table view - Should not be used unless the is an HTML data type column on the page
function Load_QuicklinkMenu(trigger, url, name, processUrlCallback) {
    if (window.QuickLink_Menu) {
        QuickLink_Menu(trigger, url, name, processUrlCallback);
    } else {
        const loadingTimeout = setTimeout(() => {
            ECP.Dialog.ShowLoading();
        }, 250);

        ECP.HTML.AddControl(ECP.HTML.ControlType.QuickLink);
        ECP.HTML.LoadControls(true).then(() => {
            clearTimeout(loadingTimeout);
            ECP.Dialog.HideLoading();

            QuickLink_Menu(trigger, url, name, processUrlCallback);
        });
    }
}

function answerCallFromQueue(CallSid, ToNumber, UserID) {
    const request = function () {
        const myRequest = new ECP.EC_Request(`SalesComm_VoiceControls_AnswerCall`);
        myRequest.SetReturnType(ECP.EC_ReturnType.Text);
        myRequest.AddRequestVariable("CallSid", CallSid, ECP.EC_Verb.Post);
        myRequest.AddRequestVariable("ToNumber", ToNumber, ECP.EC_Verb.Post);
        myRequest.AddRequestVariable("UserID", UserID, ECP.EC_Verb.Post);
        myRequest.Submit();
    };

    const temp = window.localStorage.getItem("ActiveDialerCount");
    let count = 0;
    if (temp) {
        count = parseInt(temp);
    }

    if (count > 0) {
        request();
    } else {
        window.open("Home?DashboardID=138848").focus();

        setTimeout(() => {
            request();
        }, 5000);
    }
}
